import type { TranslationDict } from '../en';

const lv: TranslationDict = {
  'header.buy': 'Pirkt',
  'header.sell': 'Pārdot',
  'spend.label': 'Jūs tērējat',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Jūs saņemat',
  'payment.label': 'Maksājuma veids',
  'payment.select': 'Izvēlēties',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Šim pārim nav pieejamu maksājumu metožu',
  'wallet.label': 'Saņemšanas maka adrese',
  'wallet.placeholderBuy': 'Ievadiet saņemšanas adresi',
  'wallet.placeholderSell': 'Ievadiet nosūtīšanas adresi',
  'wallet.validating': 'Adrese tiek pārbaudīta...',
  'wallet.invalid': 'Ievadiet derīgu maka adresi',
  'wallet.invalidServer': 'Nederīga maka adrese',
  'cta.buy': 'Pirkt {crypto}',
  'cta.sell': 'Pārdot {crypto}',
  'cta.gettingPrice': 'Meklē labāko cenu...',
  'cta.processing': 'Apstrāde...',
  'footer.poweredBy': 'Powered by ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Kursa sadalījums',
  'rate.close': 'Aizvērt',
  'rate.updatesIn': 'Kurss tiks atjaunots pēc 00:{seconds}',
  'rate.noQuote': 'Nav pieejama cenu piedāvājuma',
  'rate.exchangeRate': 'Maiņas kurss',
  'rate.processingFee': 'Apstrādes maksa',
  'rate.networkFee': 'Tīkla maksa',
  'rate.provider': 'Pakalpojumu sniedzējs',
  'toast.orderCreated': 'Pasūtījums izveidots',
  'toast.redirecting': 'Novirzīšana uz norēķinu...',
  'toast.orderFailed': 'Pasūtījums neizdevās',
  'toast.couldNotCreate': 'Neizdevās izveidot pasūtījumu',
  'toast.quoteError': 'Cenu piedāvājuma kļūda',
  'toast.noProviders': 'Nav pakalpojumu sniedzēju',
  'toast.somethingWrong': 'Kaut kas nogāja greizi',
  'error.amountZero': 'Summai jābūt lielākai par 0',
  'error.minAmountFiat': 'Minimālā summa ir {min} {currency}',
  'error.minAmountCrypto': 'Minimālā summa ir {min} {currency}',
  'error.noProviders': 'Šai kombinācijai nav pieejamu pakalpojumu sniedzēju',
  'error.currencyUnavailableBuy': 'Šī valūta nav pieejama pirkšanas pasūtījumiem',
  'error.currencyUnavailableSell': 'Šī valūta nav pieejama pārdošanas pasūtījumiem',
  'parity.info': 'Jums tiks iekasēts par {receiveAmount} {crypto}, atlikums līdz {spendAmount} {fiat} tiks ieskaitīts jūsu {partner} kontā',
  'redirect.secureBadge': 'Drošs maksājums',
  'redirect.title': 'Turpināt maksājumu',
  'redirect.description': 'Jūs tiksiet novirzīts uz {gateway}, lai pabeigtu maksājumu.',
  'redirect.countdown': 'Novirzīšana pēc {seconds}...',
  'redirect.openTab': 'Atvērt ACH jaunā cilnē',
  'redirect.cancel': 'Atcelt',
  'checkout.noOrder': 'Pasūtījums nav atrasts',
  'checkout.goBack': 'Atpakaļ',
  'checkout.expired': 'Norēķins ir beidzies',
  'checkout.expiredDesc': 'Sesija ir beigusies. Lūdzu, mēģiniet vēlreiz.',
  'checkout.startOver': 'Sākt no jauna',
  'checkout.cancel': 'Atcelt',
  'checkout.loading': 'Norēķins tiek ielādēts...',
  'checkout.iframeTitle': 'Pakalpojumu sniedzēja norēķins',
  'checkout.widgetTitle': 'Maksājuma norēķins',
  'checkout.unknownMethod': 'Nezināma norēķina metode',
  'processing.default': 'Jūsu pasūtījums tiek apstrādāts...',
  'processing.pending': 'Gaida maksājuma apstiprinājumu...',
  'processing.active': 'Jūsu darījums tiek apstrādāts...',
  'processing.generic': 'Apstrāde...',
  'processing.checkingStatus': 'Statuss tiek pārbaudīts...',
  'processing.orderId': 'Pasūtījuma ID',
  'processing.provider': 'Pakalpojumu sniedzējs',
  'processing.amount': 'Summa',
  'processing.receiving': 'Saņem',
  'processing.network': 'Tīkls',
  'processing.toAddress': 'Uz adresi',
  'processing.usuallyMinutes': 'Parasti tas aizņem dažas minūtes.',
  'processing.safeToClose': 'Varat droši aizvērt šo lapu – mēs nosūtīsim jums e-pastu, kad process būs pabeigts.',
  'complete.buyTitle': 'Pirkums pabeigts!',
  'complete.sellTitle': 'Pārdošana pabeigta!',
  'complete.buyDesc': 'Jūsu {crypto} ir nosūtīts uz jūsu maku.',
  'complete.sellDesc': 'Jūsu {fiat} izmaksa tiek apstrādāta.',
  'complete.amountBuy': 'Saņemtā summa',
  'complete.amountSell': 'Pārdotā summa',
  'complete.paidBuy': 'Samaksātā summa',
  'complete.paidSell': 'Izmaksas summa',
  'complete.network': 'Tīkls',
  'complete.wallet': 'Maks',
  'complete.transaction': 'Darījums',
  'complete.provider': 'Pakalpojumu sniedzējs',
  'complete.orderId': 'Pasūtījuma ID',
  'complete.completed': 'Pabeigts',
  'complete.viewExplorer': 'Skatīt pārlūkā',
  'complete.done': 'Gatavs',
  'errorStep.failed': 'Maksājums neizdevās',
  'errorStep.cancelled': 'Pasūtījums atcelts',
  'errorStep.expired': 'Pasūtījuma termiņš beidzies',
  'errorStep.refunded': 'Pasūtījums atmaksāts',
  'errorStep.unknown': 'Kaut kas nogāja greizi',
  'errorStep.failedBuy': 'Jūsu maksājumu neizdevās apstrādāt. Lūdzu, mēģiniet vēlreiz vai izmantojiet citu maksājuma veidu.',
  'errorStep.failedSell': 'Jūsu pārdošanu neizdevās apstrādāt. Lūdzu, mēģiniet vēlreiz.',
  'errorStep.cancelledBuy': 'Jūsu pasūtījums tika atcelts. Neviens maksājums netika apstrādāts.',
  'errorStep.cancelledSell': 'Jūsu pārdošana tika atcelta. Neviens kriptolīdzeklis netika pārsūtīts.',
  'errorStep.expiredBuy': 'Jūsu pasūtījuma termiņš ir beidzies. Lūdzu, sāciet jaunu pirkumu.',
  'errorStep.expiredSell': 'Jūsu pasūtījuma termiņš ir beidzies. Lūdzu, sāciet jaunu pārdošanu.',
  'errorStep.refundedBuy': 'Jūsu maksājums ir atmaksāts. Līdzekļiem vajadzētu parādīties jūsu kontā 5-10 darba dienu laikā.',
  'errorStep.refundedSell': 'Jūsu kriptolīdzekļi ir atgriezti. Līdzekļiem vajadzētu drīz parādīties jūsu makā.',
  'errorStep.genericDesc': 'Radās neparedzēta kļūda. Lūdzu, mēģiniet vēlreiz.',
  'errorStep.orderId': 'Pasūtījuma ID',
  'errorStep.tryAgain': 'Mēģināt vēlreiz',
  'errorStep.startOver': 'Sākt no jauna',
  'errorStep.return': 'Atgriezties',
  'errorStep.needHelp': 'Nepieciešama palīdzība? Sazinieties ar ',
  'errorStep.reference': 'Atsauce: {orderId}',
  'confirm.buyTitle': 'Apstiprināt pirkumu',
  'confirm.sellTitle': 'Apstiprināt pārdošanu',
  'confirm.loading': 'Ielādē...',
  'confirm.provider': 'Pakalpojumu sniedzējs',
  'confirm.youPay': 'Jūs maksājat',
  'confirm.youSell': 'Jūs pārdodat',
  'confirm.youReceive': 'Jūs saņemat',
  'confirm.wallet': 'Maks',
  'confirm.network': 'Tīkls',
  'confirm.refundAddress': 'Atmaksas adrese',
  'confirm.parityNote': 'Pakalpojumu sniedzēja iekasētā summa var atšķirties. Atlikums līdz {amount} {crypto} tiks ieskaitīts jūsu {partner} kontā.',
  'confirm.processing': 'Apstrāde...',
  'confirm.confirmPay': 'Apstiprināt un maksāt',
  'confirm.confirmSell': 'Apstiprināt un pārdot',
  'confirm.payout': '{currency} izmaksa',
  'modal.selectFiat': 'Izvēlēties fiat valūtu',
  'modal.selectCrypto': 'Izvēlēties kriptovalūtu',
  'modal.choosePayment': 'Izvēlēties maksājuma veidu',
  'modal.selectCountry': 'Izvēlēties valsti',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Populāri',
  'modal.recommended': 'Ieteicami',
  'modal.noCurrencies': 'Valūtas nav atrastas',
  'modal.noPaymentMethods': 'Maksājumu metodes nav atrastas',
  'modal.noCountries': 'Valstis nav atrastas',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Atrašanās vieta',
  'settings.darkMode': 'Tumšais režīms',
  'settings.privacy': 'Privātuma politika',
  'settings.terms': 'Lietošanas noteikumi',
  'settings.language': 'Valoda',
  // ─── Additional ───
  'modal.chooseRamp': 'Izvēlēties Ramp',
  'modal.bestPrice': 'Labākā cena',
  'modal.noQuotes': 'Šim pieprasījumam nav pieejamu cenu piedāvājumu',
  'modal.noProvidersFound': 'Pakalpojumu sniedzēji nav atrasti',
  'payment.unavailableFor': 'Nav pieejamu maksājumu metožu {currency} valūtai',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'Neizdevās izveidot pasūtījumu',
  'errorStep.returnToMerchant': 'Atgriezties pie tirgotāja',
  'confirm.cryptoOnNetwork': '{crypto} {network} tīklā',
  'payment.name.card': 'Karte',
  'payment.name.bankTransfer': 'Bankas pārskaitījums',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default lv;
